module.exports = __webpack_public_path__ + "static/media/logo_mini_white.3bc1ca48.png";